/** @format */

module.exports = {
	title: "Unsubscribed",
	description:
		"Sorry for the inconvenience. You will no longer be notified about new activities on the Eagle-edu platform.",
};
